import React from 'react';
import './ValidationReferencesFrancoComment.scss';
import IconItem from '../../../../../../components/Item/IconItem/IconItem';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import { Trans, useTranslation } from 'react-i18next';
import TextareaInput from 'components/inputs/TextareaInput/TextareaInput';
import {useDispatch} from 'react-redux';
import {setCloseModal} from 'store/slices/proformaAutomotorModal.slice';

type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
};


const ValidationReferencesFrancoComment: React.FC<Props> = (props) => {

  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const dispatch = useDispatch();

  const handleClose = () => {
    props.setOpenModal(false);
    dispatch(setCloseModal(true));
  };

  const [message, setMessage] = React.useState<string>('');


  const addComment = () => {
    if (message.length > 0) {
      proformaFile.comment_references_franco = message;
      localStorage.setItem('proformaFileInProgress', JSON.stringify(proformaFile));
    }

    props.setStepModal('ValidationReferencesResultInfo');
  };

  return (
    <div className="validation-custumer-order-comment-franco-modal" >
      <div className="close upload_order_info_franco_comment_close">
        <IconItem icon={faClose} onClick={() => { handleClose(); }} />
      </div>
      <div className="validation-customer-modal-body">
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-title">{t('_ref_franco_comment')}</div>
          <div className="validation-customer-modal-subtitle">
            <Trans
              i18nKey="_validation_message_franco"
              components={{ bold: <br /> }}

            />
          </div>
        </div>
        <div className="validation-customer-modal-row">
          <TextareaInput noResize rows={10} onChange={(e) => setMessage(e.target.value)} />
        </div>

        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-button">
            <DefaultButton className="validation-customer-modal-btn  upload_order_info_franco_comment" text={t('_send_my_order_as_is')} onClick={() => { addComment(); }} />


          </div>

        </div>

      </div>
    </div>
  );

};

ValidationReferencesFrancoComment.displayName = 'ValidationReferencesFrancoComment';

export default ValidationReferencesFrancoComment;